/**
 * Cómo se LEE cada rol en pantalla. El valor guardado no cambia (`asesora`, `medico`, `cosmetologa`… son el
 * enum `user_role` de la base y viajan en el token, compartidos con DraIA y Loyaltyapp); sólo la etiqueta es
 * neutra: también hay hombres ("cosmetología", no "cosmetóloga"; "equipo médico", no "médico").
 */
export const ROL_ETIQUETA: Record<string, string> = {
  medico: 'equipo médico',
  cosmetologa: 'cosmetología',
  recepcion: 'recepción',
  asesora: 'ventas / asesoría',
};
export const rolEtiqueta = (r: string | null | undefined) => (r ? ROL_ETIQUETA[r] || r : 'sin rol');
/**
 * El rol de una persona en Comisiones y en Cuentas: una cuenta que NO es del equipo médico ni de cosmetología pero que
 * la clínica marcó como que también atiende pacientes (Administración → Cuentas; la doctora dueña con su cuenta de
 * admin) se lee "admin · atiende pacientes". El API manda `clinico` (regla en api/src/lib/equipo-clinico.ts).
 */
export const rolPersona = (r: string | null | undefined, clinico?: boolean) =>
  (clinico && r !== 'medico' && r !== 'cosmetologa' ? `${rolEtiqueta(r)} · atiende pacientes` : rolEtiqueta(r));

/** Quién abre "Mis comisiones" (sólo lo suyo; el servidor filtra con el token). El admin ve todo en "Comisiones". */
export const ROLES_MIS_COMISIONES = ['medico', 'cosmetologa', 'recepcion', 'asesora'];
